// argumentがundefined and nullじゃないかをチェックする
window.isSet = (any) => {
  return any !== undefined && any !== null
}

// prepend child method
// Element.prototype.prependChild = function ( el ) {
//   this.insertBefore( el, this.firstChild )
// };
